<template>
  <v-dialog persistent v-model="dialog" width="300">
    <v-card
      class="pb-2 pt-3"
      :color="color"
      :class="loadingClasses"
      :style="loadingStyles"
    >
      <v-card-text>
        {{ text }}
        <v-progress-linear
          indeterminate
          color="hsl(240deg 60% 75%)"
          class="mb-0 mt-1"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'Modal',
  props: {
    value: {
      type: [Boolean, String],
      default: false,
    },
    width: {
      default: '500',
    },
    loadingClasses: {
      type: String,
    },
    loadingStyles: {
      type: String,
    },
    color: {
      type: String,
      default: 'hsl(240deg 20% 90%)',
    },

    text: {
      type: String,
      default: ' لطفا منتظر بمانید ...',
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {},
};
</script>
<style></style>
